module.exports = __webpack_public_path__ + "assets/e1590a9e1f59ded8ee991853f4f0bd17.mp4";